import { NavigateOptions, useNavigate, useParams } from 'react-router-dom';

export const useLangNavigate = () => {
  const { lang } = useParams<{ lang?: string }>();

  const navigate = useNavigate();

  const navigateWithLang = (path: string, options?: NavigateOptions) => {
    if (!path.startsWith('/')) {
      console.error(`MapsWithLang: Path must start with a slash (/). Received: "${path}"`);
      throw new Error(`MapsWithLang: Invalid path. Path must start with a slash (/). Received: "${path}"`);
    }

    if (!lang) {
      navigate(path, options);
      return;
    }

    const targetPath = `/${lang}${path}`;

    navigate(targetPath, options);
  };

  return { lang, navigateWithLang };
};
